/**
 * Tiny entry loaded by index.html ahead of the app: on a plain checkout URL
 * it starts the payment session and the checkout code's download while
 * the app is still downloading (see pages/Sales/Checkout/checkoutEarlyIntent.ts),
 * and on any checkout page the partner card form's own code
 * (pages/Sales/Checkout/partnerFrameWarm.ts).
 * Everywhere else it does nothing.
 */
import {
	preloadCheckoutRoute,
	startEarlyCheckoutIntent,
} from "./pages/Sales/Checkout/checkoutEarlyIntent";
import { warmPartnerFrames } from "./pages/Sales/Checkout/partnerFrameWarm";

startEarlyCheckoutIntent();
preloadCheckoutRoute();
// #2917: on any checkout page, start downloading the partner card form's code
// now (the HTML already preloads its loader script), not after the app has
// booted. Direct links gained only 2-21% when this waited for the app.
if (
	typeof window !== "undefined" &&
	/^\/checkout(\/|$)/.test(window.location.pathname)
) {
	const warm = () => void warmPartnerFrames();
	if (document.body) warm();
	else document.addEventListener("DOMContentLoaded", warm, { once: true });
}
